import payload_plugin_qLmFnukI99 from "/media/saeid/projects/Athena/client/node_modules/@pinia/nuxt/dist/runtime/payload-plugin.js";
import revive_payload_client_4sVQNw7RlN from "/media/saeid/projects/Athena/client/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/media/saeid/projects/Athena/client/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/media/saeid/projects/Athena/client/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/media/saeid/projects/Athena/client/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/media/saeid/projects/Athena/client/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/media/saeid/projects/Athena/client/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/media/saeid/projects/Athena/client/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/media/saeid/projects/Athena/client/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_zlvi6dcIsi from "/media/saeid/projects/Athena/client/node_modules/.cache/nuxt/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/media/saeid/projects/Athena/client/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_gab9g3XuEx from "/media/saeid/projects/Athena/client/node_modules/nuxt-aos/dist/runtime/plugin.js";
import motion_jmBwdqbgTJ from "/media/saeid/projects/Athena/client/node_modules/@vueuse/motion/dist/nuxt/runtime/templates/motion.js";
import unocss_RAHspWIKy3 from "/media/saeid/projects/Athena/client/node_modules/.cache/nuxt/.nuxt/unocss.mjs";
import plugin_client_bwUJlHa9fG from "/media/saeid/projects/Athena/client/modules/sentry/runtime/plugin.client.ts";
import maskito_3LyKsugjJ8 from "/media/saeid/projects/Athena/client/app/plugins/maskito.ts";
export default [
  payload_plugin_qLmFnukI99,
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_zlvi6dcIsi,
  prefetch_client_5tzzN0oIVL,
  plugin_gab9g3XuEx,
  motion_jmBwdqbgTJ,
  unocss_RAHspWIKy3,
  plugin_client_bwUJlHa9fG,
  maskito_3LyKsugjJ8
]